import { Typography } from '@mui/material'
import React, { FunctionComponent } from 'react'

export const LoadingMessage: FunctionComponent<{ isLoading: boolean }> = ({ isLoading }) =>
  isLoading ? (
    <Typography variant="h4" component="p">
      Daten werden geladen
    </Typography>
  ) : null
